import React, { lazy, useEffect, useCallback, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Helmet } from 'react-helmet';
import {
  isEmpty as _isEmpty,
  compact as _compact,
  forEach as _forEach,
  isUndefined as _isUndefined,
  some as _some,
  has as _has,
  map as _map,
  filter as _filter,
  cloneDeep as _cloneDeep
} from 'lodash-es';
import { useLocation } from 'react-router-dom';
import {
  getAvailableNavigationMenus,
  getNavigationSubMenus,
  getFeatureMenus
} from 'redux/Navigation/Navigation.action';
import Footer from 'layouts/Footer/Footer';
import {
  componentLoaderPromise,
  getBillPlanExpiryDateDifference,
  isBillPlanIDEnabled,
  mouseflowTrack,
  getDeviceInformation,
  unixToDateFormat
} from 'utilities/utilities_exports';
import { isBrowser, isMobile, isTablet } from 'react-device-detect';
import { getAccountData, getLinkedWMSData, getCalenderEvents } from 'redux/Account/Account.action';
import { ProductFruits } from 'react-product-fruits';
import { getStoreList, getIntegrationErrorMappings } from 'Modules/Connect/redux/ConnectList/Connect.action';
import Cookies from 'js-cookie';
import {
  getMetricDefinition,
  getMetricDimensionMappingViaSphere,
  getChromeMetrics
} from 'redux/MetricDefinition/MetricDefinition.action';
import { getConnectJournalData } from 'redux/ConnectJournal/ConnectJournal.action';
import { apiServices } from 'redux/utils/api_services';
import { SubscriptionDetailsContants } from 'redux/SubscriptionDetails/SubscriptionDetails.constants';
import { getDataFromApiAction } from 'components/Atoms/GraasApiUtility/GraasApiUtility.action';
import { skippedChannelFromLits } from 'Modules/Connect/components/ConnectStoreList/utility';
import { datadogRum } from '@datadog/browser-rum';
import { WorkSpaceConstants } from 'redux/WorkSpace/WorkSpace.constants';
import ScreenSizePopup from 'Modules/Home/components/ScreenSizePopup/ScreenSizePopup';
import MainHeader from 'layouts/MainHeader/MainHeader';
import DemoContent from 'Modules/Demo/DemoContent/DemoContent';
import MainSidebar from 'layouts/MainSidebar/MainSidebar';
import queryString from 'query-string';
import clevertap from 'clevertap-web-sdk';
import { nanoid } from 'nanoid';
import { accountConstants } from 'redux/Account/Account.constants';
import { message } from 'antd';
import { useTranslation } from 'react-i18next';
import moment from 'moment';
import { getIsDemoHost } from 'utilities/demo_utilities';

const ReauthPopUp = lazy(() =>
  componentLoaderPromise(() => import(/* webpackChunkName: 'ReauthPopUp' */ 'layouts/ReauthPopUp'))
);

const UpgradeContainer = lazy(() =>
  componentLoaderPromise(() =>
    import(/* webpackChunkName: 'UpgradeContainer' */ 'pages/UpgradeContainer/UpgradeContainer')
  )
);
const UpgradePopupBackground = lazy(() =>
  componentLoaderPromise(() =>
    import(
      /* webpackChunkName: 'UpgradePopupBackground' */ 'components/Atoms/UpgradePopupBackground/UpgradePopupBackground'
    )
  )
);

const AccessDenied = lazy(() =>
  componentLoaderPromise(() => import(/* webpackChunkName: 'AccessDenied' */ 'pages/AccessDeniedContainer'))
);

const DemoHostPage = lazy(() =>
  componentLoaderPromise(() => import(/* webpackChunkName: 'DemoHostPage' */ 'Modules/Demo/DemoHostPage'))
);

const PageSkeleton = props => {
  const { loading, children } = props;
  const dispatch = useDispatch();
  const { t } = useTranslation();
  let location = useLocation();
  const navigationMenus = useSelector(state => state?.Navigation);

  const availableMenus = navigationMenus?.availableMenus;
  const userData = useSelector(state => state?.User?.userData);
  const accountDetails = useSelector(state => state?.User?.accountDetails);
  const selectedIntegrationGoals = accountDetails?.selectedIntegrationGoals || [];
  let restrictBillplanPopup = useSelector(state => state?.User?.accountDetails?.userDetails?.restrictBillplanPopup);
  const [isAccessToPage, setIsAccessToPage] = useState(true);
  const merchantID = accountDetails?.merchantID || '';
  const userName = accountDetails?.userDetails?.name || '';
  const freshchatInitialized = Cookies.get('freshchatInitialized');
  const connectedList = useSelector(state => state.Account?.stores?.activeList);
  const urlPermissionEnabledAccountForSupportUser =
    process.env.REACT_APP_URL_RESTRICTION_ENABLED_ACCOUNTS_FOR_SUPPORT_USER.split(',');
  const [isOneTimePopupRequired, setIsOneTimePopupRequired] = useState(false);
  const billPlanDetails = useSelector(state => state?.SubscriptionDetails?.billingPlanDetails?.data);
  const [isCreditExpired, setIsCreditExpired] = useState(false);
  const groupedStoresListCollection = useSelector(state => state?.Connect);
  const [isChannelConnected, setIsChannelConnected] = useState(true);
  const [isExpired, setIsExpired] = useState(false);
  const [showRemindMeLater, setShowRemindMeLater] = useState(true);
  const [totalActivePlans, setTotalActivePlans] = useState(0);
  const [isFeaturesEnabled, setIsFeaturesEnabled] = useState(false);
  const [showUpgrade, setShowUpgrade] = useState(true);
  const [isPopupNeedToShow, setIsPopupNeedToShow] = useState(false);
  const [isExecutorPopup, setIsExecutorPopup] = useState(false);
  const [isDemoAccount, setIsDemoAccount] = useState(false);
  const [isBillplanTransitionPopupShown, setIsBillplanTransitionPopupShown] = useState('');
  const isSupportUser = userData?.userName?.includes('[admin]');
  // const workSpaceState = useSelector(state => state.WorkSpace);
  const [isPlanOneTimePopupRequired, setIsPlanOneTimePopupRequired] = useState(false);
  const hasWriteAccess = useSelector(state => state?.Account?.hasWriteAccess);
  const [isFreeTrail, setIsFreeTrail] = useState(false);
  const isDemoHost = useSelector(state => state?.Account?.isDemoHost);
  const overallBillPlanDetailsList =
    useSelector(state => state?.SubscriptionDetails?.overallBillPlanDetails?.data?.CLASSIC) || [];

  const pathname = window.location.pathname;
  const dashboardDetails = {
    IN_US: ['combined-ws', 'custom_dashboard'],
    STATUS: ['active', 'success']
  };

  const hideSidebarPaths = ['/executor/chat'];

  const user = useSelector(state => state?.User?.userData);
  const [isPopupVisible, setIsPopupVisible] = useState(false);
  const [isPopupShown, setIsPopupShown] = useState(localStorage.getItem('screenSizePopupShown') === 'true');

  const parsedQueryString = queryString.parse(window.location.search);

  useEffect(() => {
    const { innerWidth: width } = window;
    if (width < 1240 || isMobile || isTablet) {
      if (!isPopupShown) {
        setIsPopupVisible(true);
      }
    }
  }, [isPopupShown]);

  useEffect(() => {
    if (
      !_isUndefined(accountDetails) &&
      !_isEmpty(accountDetails) &&
      !accountDetails?.loading &&
      !accountDetails?.error &&
      accountDetails?.merchantID
    ) {
      if (accountDetails?.countryCode === 'IN' && accountDetails?.linkedChannelTypes?.length === 0) {
        setIsBillplanTransitionPopupShown(true);
      } else {
        setIsBillplanTransitionPopupShown(accountDetails?.userDetails?.isBillplanTransitionPopupShown || false);
      }
      if (
        accountDetails?.userDetails?.SELLinALLId === process.env.REACT_APP_DEMO_ACCOUNT_EMAIL ||
        accountDetails?.userDetails?.SELLinALLId === process.env.REACT_APP_DEMO_IN_ACCOUNT_EMAIL
      ) {
        dispatch({
          type: accountConstants.UPDATE_ACCOUNT_ACCESS_TYPE,
          payload: { hasWriteAccess: false }
        });
      } else {
        dispatch({
          type: accountConstants.UPDATE_ACCOUNT_ACCESS_TYPE,
          payload: { hasWriteAccess: true }
        });
      }
    }
  }, [accountDetails]);

  const handleContinue = () => {
    setIsPopupVisible(false);
    setIsPopupShown(true);
    localStorage.setItem('screenSizePopupShown', 'true');
    mouseflowTrack(
      {
        username: accountDetails?.userData?.userName,
        email: accountDetails?.accountDetails?.userDetails?.SELLinALLAuth?.SELLinALLId || '',
        storeCode: !hasWriteAccess ? Cookies.get('storeCode') : accountDetails?.accountDetails?.merchantID || '',
        isDemoAccount: !hasWriteAccess
      },
      'SCREEN_SIZE_POPUP_CONTINUE_CLICKED'
    );
  };
  useEffect(() => {
    if (
      process.env.NODE_ENV === 'production' &&
      user &&
      !_isEmpty(process.env.REACT_APP_DATADOG_APPLICATION_ID) &&
      !_isEmpty(process.env.REACT_APP_DATADOG_CLIENT_TOKEN)
    ) {
      datadogRum.setUser({
        id: user.userId,
        name: user.merchantID,
        email: user.userName,
        env_mode: process.env.REACT_APP_ENV
      });
    }
  }, [user]);

  useEffect(() => {
    if (
      !_isUndefined(accountDetails) &&
      !_isEmpty(accountDetails) &&
      !_isUndefined(accountDetails?.accountNumber) &&
      accountDetails?.isBillPlanEnabled
    ) {
      overallBillPlanDetails();
      getBillingPlanDetails();
      getBillingCreditDetails();
      // set API call for every 5 Minutes to check BillPlan Expiry status and creditBalance status.
      setInterval(getBillingPlanDetails, 300000);
      setInterval(getBillingCreditDetails, 300000);
    }
  }, [dispatch, accountDetails]);

  useEffect(() => {
    if (!_isUndefined(billPlanDetails) && !_isEmpty(overallBillPlanDetailsList)) {
      const restrictedBillPlanID =
        overallBillPlanDetailsList
          .filter(plan => plan.planCategory === 'STARTER' || plan.planCategory === 'FREE')
          .map(plan => plan.billPlanID) || [];
      if (billPlanDetails?.subscriptionState === 'PAID') {
        checkCreditExpiredDateState(billPlanDetails);
      }
      if (billPlanDetails?.subscriptionState === 'FREE') {
        setIsFreeTrail(true);
        setPlanExpiredState(billPlanDetails?.timeExpire);
      }
      isFeaturedAvailable(restrictedBillPlanID);
    }
  }, [billPlanDetails, overallBillPlanDetailsList]);

  useEffect(() => {
    if (!_isUndefined(billPlanDetails) && !_isUndefined(accountDetails) && totalActivePlans > 0) {
      upgradePopupValidation();
    }
  }, [
    billPlanDetails,
    accountDetails,
    totalActivePlans,
    isOneTimePopupRequired,
    isPlanOneTimePopupRequired,
    isCreditExpired,
    window.location.href
  ]);

  useEffect(() => {
    setPopupBackgroundCondition();
    const paramObj = queryString.parse(window.location.search);
    if (
      !_isEmpty(paramObj?.Perm) &&
      !_isEmpty(paramObj?.nickNameID) &&
      paramObj?.nickNameID.split('-')?.[0] === 'google'
    ) {
      if (paramObj?.Perm === 'SUCCESS') {
        message.success(`${t('GRAAS_GOOGLE_ACCOUNT_ADDED_SUCCESSFULLY_GRAAS')}`);
      } else {
        message.error(`${t('GRAAS_FAILED_TO_CONNECT_GOOGLE_GRAAS')}`);
      }
    }
  }, [window.location.href]);

  const checkChannelConnected = useCallback(() => {
    if (groupedStoresListCollection?.groupedStoresList && !isSupportUser) {
      const categoriesToCheck = Object.keys(groupedStoresListCollection?.groupedStoresList);
      let channelsToCheck = [];
      _forEach(categoriesToCheck, category => {
        const categorizedStores = _map(groupedStoresListCollection?.groupedStoresList[category], t => t?.key) || [];
        channelsToCheck = [...channelsToCheck, ...categorizedStores];
      });
      if (!_isEmpty(channelsToCheck)) {
        const filtered_channel = _filter(channelsToCheck, ch => !skippedChannelFromLits?.includes(ch)) || [];
        let hasAnyChannelConnected = _some(
          filtered_channel,
          key => _has(accountDetails, key) && accountDetails[key] !== null
        );
        setIsChannelConnected(hasAnyChannelConnected);
      }
    } else {
      setIsChannelConnected(true);
    }
  }, [accountDetails, groupedStoresListCollection]);

  useEffect(() => {
    if (
      !accountDetails?.loading &&
      !accountDetails?.error &&
      !groupedStoresListCollection?.stores?.loading &&
      !groupedStoresListCollection?.stores?.error
    ) {
      checkChannelConnected();
    }
  }, [
    accountDetails?.error,
    accountDetails?.loading,
    groupedStoresListCollection?.stores?.error,
    groupedStoresListCollection?.stores?.loading
  ]);

  // need to handle cache for this API
  useEffect(() => {
    dispatch(getIntegrationErrorMappings());
  }, [dispatch]);

  //----------------------------------clevertap start----------------------------------------------------------------------------------------
  useEffect(() => {
    locationChangeEvent(location, parsedQueryString);
  }, [JSON.stringify(location), JSON.stringify(parsedQueryString)]);

  const locationChangeEvent = (location, parsedQueryString) => {
    const deviceInformation = getDeviceInformation();
    const localStorageValue = localStorage.getItem('signUp');
    let signUpData = {};
    if (!_isEmpty(localStorageValue)) {
      signUpData = JSON.parse(localStorageValue);
    }
    const { pathname, search } = location;
    let cleverTapPayload = {
      page_name: pathname,
      loadtime: new Date().toLocaleString(),
      URL: `${window.location.origin}${pathname}`,
      Params: search,
      Device: deviceInformation.deviceType || '',
      Timestamp: new Date().getTime(),
      Browser: deviceInformation?.browser?.name || '',
      Language: 'EN',
      OS: deviceInformation?.os?.name || '',
      Date: new Date().toISOString(),
      Time: new Date().getTime(),
      merchatID: signUpData?.merchantID,
      Name: signUpData?.SELLinALLId,
      Email: signUpData?.SELLinALLId,
      Country: signUpData?.countryCode,
      'Referral URL': document.referrer,
      'Mobile Number': signUpData?.phoneNumber,
      'Referral URL': parsedQueryString?.referralUrl || '',
      'Landing Page': parsedQueryString?.landingPage || '',
      'UTM Source': parsedQueryString?.utm_source || '',
      'UTM Medium': parsedQueryString?.utm_medium || '',
      'UTM Campaign': parsedQueryString?.utm_campaign || '',
      'UTM Content': parsedQueryString?.utm_content || ''
    };
    clevertap.event?.push('Page Viewed', cleverTapPayload);
    console.log('CleverTap event pushed for:', cleverTapPayload);
  };
  //----------------------------------clevertap end----------------------------------------------------------------------------------------

  const getBillingPlanDetails = useCallback(async () => {
    const apiUrl = `${apiServices['billingServ']}/services/accountBillPlans/${accountDetails?.accountNumber}`;
    const response = await getDataFromApiAction(apiUrl);
    if (response?.status === 'success') {
      dispatch({ type: SubscriptionDetailsContants.GET_SUBSCRIPTION_BILLPLANDETAILS_SUCCESS, payload: response });
    }
  });
  const getBillingCreditDetails = useCallback(async () => {
    const apiUrl = `${apiServices['billingServ']}/services/billingJournal/creditData`;
    const response = await getDataFromApiAction(apiUrl);
    const responseData = response?.response || [];
    if (responseData?.length > 0) {
      const responsePayload = { data: responseData };
      dispatch({
        type: SubscriptionDetailsContants.GET_SUBSCRIPTION_CREDITPLANDETAILS_SUCCESS,
        payload: responsePayload
      });
    }
  });

  const overallBillPlanDetails = useCallback(async () => {
    const apiUrl = `${apiServices['billingServ']}/services/billPlan?countryCode=${accountDetails?.countryCode}`;
    const response = await getDataFromApiAction(apiUrl);
    if (response?.status === 'success') {
      dispatch({ type: SubscriptionDetailsContants.GET_SUBSCRIPTION_OVERALLBILLPLAN_SUCCESS, payload: response });
    }
  });

  const checkCreditExpiredDateState = billPlanDetails => {
    if (billPlanDetails?.queuedPlan?.length === 0) {
      let daysleft = getBillPlanExpiryDateDifference(billPlanDetails?.timeExpire, billPlanDetails?.timeZone);
      if (daysleft === 7) {
        setShowRemindMeLater(true);
      } else {
        setShowRemindMeLater(false);
      }
      if (daysleft <= 0) {
        setIsCreditExpired(true);
      } else if (daysleft === 7 || daysleft === 3) {
        setIsPlanOneTimePopupRequired(true);
      }
    }
  };

  const setPlanExpiredState = timeExpire => {
    const remDays = getBillPlanExpiryDateDifference(timeExpire, billPlanDetails?.timeZone);
    if (remDays <= 3) {
      setShowRemindMeLater(false);
    } else {
      setShowRemindMeLater(true);
    }
    if (remDays <= 0) {
      setIsExpired(true);
    } else if (remDays === 7 || remDays === 3) {
      setIsOneTimePopupRequired(true);
    }
  };

  const isFeaturedAvailable = restrictedBillPlanID => {
    let count = 1;
    if (!restrictedBillPlanID.some(plan => billPlanDetails?.billPlanID?.includes(plan))) {
      count += 1;
    }
    if (billPlanDetails?.queuedPlan?.length > 0) {
      count += billPlanDetails?.queuedPlan?.length;
    }
    if (count > 1) {
      setIsFeaturesEnabled(true);
    }
    setTotalActivePlans(count);
  };

  const upgradePopupValidation = () => {
    var isPopupRequired = false;
    const path = window.location.pathname;
    const isExecutorPage = path?.includes('/executor/');
    let isRestrictedRequired = false;
    if (accountDetails?.isBillPlanEnabled && isFreeTrail) {
      if (
        isExecutorPage &&
        !isBillPlanIDEnabled(billPlanDetails?.addOnModules, 'DEFAULT_BILLING_EXECUTE') &&
        !isExpired
      ) {
        // isPopupRequired = true;
        setIsExecutorPopup(isPopupRequired);
      } else if (isExpired && path !== '/pricingDetails' && path !== '/planDetails' && !isSupportUser) {
        isPopupRequired = true;
      } else if (
        !Cookies.get(accountDetails?.merchantID + '-IsExpiryPopUpShown') &&
        isOneTimePopupRequired &&
        path !== '/pricingDetails' &&
        path !== '/planDetails' &&
        totalActivePlans === 1
      ) {
        isPopupRequired = true;
        isRestrictedRequired = true;
      }
    } else if (
      accountDetails?.isBillPlanEnabled &&
      !isFreeTrail &&
      path !== '/pricingDetails' &&
      path !== '/planDetails' &&
      !isSupportUser
    ) {
      if (!isFeaturesEnabled && !isBillplanTransitionPopupShown) {
        isPopupRequired = true;
      } else if (isCreditExpired) {
        isPopupRequired = true;
      } else if (
        !Cookies.get(accountDetails?.merchantID + '-IsExpiryPopUpShown') &&
        isPlanOneTimePopupRequired &&
        path !== '/pricingDetails' &&
        path !== '/planDetails'
      ) {
        isPopupRequired = true;
      }
    }
    setIsPopupNeedToShow(isPopupRequired);
    if (isRestrictedRequired) {
      isPopupRestricted();
    }
  };

  const isPopupRestricted = () => {
    const remDays = getBillPlanExpiryDateDifference(billPlanDetails?.timeExpire, billPlanDetails?.timeZone);
    if (remDays > 3 && remDays < 7 && restrictBillplanPopup && isFreeTrail) {
      setIsPopupNeedToShow(false);
    }
  };

  const setPopupBackgroundCondition = () => {
    const path = window.location.pathname;
    var isAccessible = false;
    if (!_isUndefined(accountDetails) && !_isUndefined(billPlanDetails) && !isSupportUser) {
      if (
        accountDetails?.isBillPlanEnabled &&
        billPlanDetails?.isFreeTrail &&
        path !== '/pricingDetails' &&
        path !== '/planDetails' &&
        isExpired &&
        totalActivePlans <= 1
      ) {
        isAccessible = true;
      } else if (accountDetails?.isBillPlanEnabled && !billPlanDetails?.isFreeTrail && isCreditExpired) {
        if (path !== '/pricingDetails' && path !== '/planDetails') {
          isAccessible = true;
        }
      }
    }
    return isAccessible;
  };

  const getSubmenu = () => {
    const currentPath = window.location.href.split('/');
    const currentSubMenu = currentPath[currentPath?.length - 1].split('?')[0];
    return currentSubMenu;
  };

  // --- if forcefully changed URL then this function will call
  const checkMenuPermission = useCallback(
    menuList => {
      const currentUrlPathName = window.location.pathname;
      const split = _compact(currentUrlPathName?.split('/')) || [];
      setIsAccessToPage(true);

      if (
        (!isSupportUser ||
          (isSupportUser && urlPermissionEnabledAccountForSupportUser.includes(userData?.merchantID))) &&
        !_isEmpty(menuList)
      ) {
        let flag = false;
        _forEach(split, item => {
          if (menuList?.hasOwnProperty(item)) {
            if (menuList[item] === false && !flag) {
              setIsAccessToPage(false);
              flag = true;
            }
          } else {
            flag = false;
            return null;
          }
        });
      }
    },
    [urlPermissionEnabledAccountForSupportUser, userData?.merchantID, userData?.userName]
  );
  // productFruits.init('ZeuovdsXDkbT3Avh', 'en', { username: 'Graas' });
  // --- Feature is for if forcefully change url then show subscribe page

  const checkMenuPermissionBeta = useCallback(
    permissions => {
      const currentUrlPathName = window.location.pathname;
      setIsAccessToPage(true);
      if (
        !isSupportUser ||
        (isSupportUser && urlPermissionEnabledAccountForSupportUser.includes(userData?.merchantID))
      ) {
        for (let i in permissions) {
          let menuItem = permissions[i];
          let menuItemPath = menuItem?.basePath || menuItem?.path;
          if (menuItemPath === currentUrlPathName) {
            if (!menuItem?.isEnabled) {
              setIsAccessToPage(false);
              break;
            }
          }
        }
      }
    },
    [urlPermissionEnabledAccountForSupportUser, userData?.merchantID, userData?.userName]
  );

  const getSharedDetails = async id => {
    let url = `${apiServices['account']}/services/collaboration/WORK_SPACE/${id}`;
    const response = await getDataFromApiAction(url);
    dispatch({ type: WorkSpaceConstants.UPDATE_SELECTED_DASHBOARD, payload: id });
  };

  useEffect(() => {
    if (
      !navigationMenus?.loading &&
      !navigationMenus?.error &&
      !_isEmpty(navigationMenus?.permissions) &&
      !accountDetails?.loading
    ) {
      if (navigationMenus.permissions.hasOwnProperty('loading') && !navigationMenus.permissions['loading']) {
        if (accountDetails?.isBillPlanEnabled) {
          checkMenuPermissionBeta(navigationMenus?.userMenu);
        } else {
          checkMenuPermission(navigationMenus?.permissions);
        }
      }
    }
  }, [
    checkMenuPermission,
    navigationMenus.error,
    navigationMenus.loading,
    navigationMenus.permissions,
    props?.pathName,
    accountDetails
  ]);

  // --- Get current submenus on refresh page
  const getCurrentSubmenus = useCallback(() => {
    let path = location?.pathname?.split('/')?.filter(e => !_isEmpty(e))?.[0] || '';
    // ! path is chart builder then need to show analyze submenus
    if (path === 'chart-builder') path = 'analyze';
    // TODO: Need to change when execute migrated to react
    if (path === 'executor') path = 'execute';
    let allMenus = accountDetails?.isNewMenuStructureEnabled ? navigationMenus?.menu : navigationMenus?.userMenu;
    const selectedObjSubmenu = (!_isEmpty(path) && allMenus?.find(element => element.id === `nav_${path}`)) || {};

    if (!_isEmpty(selectedObjSubmenu)) {
      if (accountDetails?.isNewMenuStructureEnabled) {
        let subMenuList = _cloneDeep(selectedObjSubmenu?.subMenu);
        let finalSubMenus = [];
        if (!accountDetails?.isBillPlanEnabled) {
          _forEach(subMenuList, subMenu => {
            if (!_isEmpty(subMenu?.menu)) {
              let menusList = subMenu?.menu;
              let finalMenuList = [];
              _forEach(menusList, menuObj => {
                if (availableMenus.includes(menuObj?.id)) {
                  finalMenuList?.push(menuObj);
                }
              });
              if (!_isEmpty(finalMenuList)) {
                subMenu.menu = finalMenuList;
                finalSubMenus?.push(subMenu);
              }
            }
          });
        } else {
          finalSubMenus = subMenuList;
        }
        dispatch(getNavigationSubMenus(finalSubMenus || []));
      } else {
        dispatch(getNavigationSubMenus(selectedObjSubmenu?.subMenu || []));
      }
    } else {
      dispatch(getNavigationSubMenus([]));
    }
  }, [dispatch, location.pathname, navigationMenus.menu, accountDetails?.isNewMenuStructureEnabled]);

  useEffect(() => {
    if (!navigationMenus?.loading && !navigationMenus?.error && !accountDetails?.loading) getCurrentSubmenus();
  }, [getCurrentSubmenus, navigationMenus.error, navigationMenus.loading, accountDetails]);

  useEffect(() => {
    if (!_isEmpty(connectedList)) {
      const payload = {
        startDate: moment().subtract(8, 'd').format('YYYY-MM-DD'),
        endDate: moment().subtract(1, 'd').format('YYYY-MM-DD'),
        nickNameId: connectedList.join(),
        isLocalizationRequried: 'false'
      };
      dispatch(getConnectJournalData(payload, 'global'));
    }
  }, [connectedList]);

  useEffect(() => {
    const isDemoPage = getIsDemoHost();
    dispatch({
      type: accountConstants.SET_IS_DEMO_HOST,
      payload: isDemoPage
    });
  }, [dispatch]);

  // --- Get Menus
  useEffect(() => {
    dispatch(getAccountData());
    dispatch(getLinkedWMSData());
    dispatch(getCalenderEvents());
    dispatch(
      getChromeMetrics({
        pathname: location.pathname,
        search: location.search,
        traceId: nanoid()
      })
    );
    dispatch(getMetricDefinition({ isAddMetricSymbol: 'true', trace_id: nanoid(), path: location.pathname }));
    dispatch(
      getMetricDimensionMappingViaSphere({
        loadNewWarehouse: true,
        channel: '',
        trace_id: nanoid(),
        path: location.pathname
      })
    );
  }, [dispatch]);

  useEffect(() => {
    if (!_isEmpty(accountDetails) && !accountDetails?.loading && !accountDetails?.error) {
      dispatch(getAvailableNavigationMenus(accountDetails?.isNewMenuStructureEnabled));
      dispatch(getFeatureMenus());
    }
  }, [dispatch, accountDetails]);

  useEffect(() => {
    if (
      !accountDetails?.loading &&
      !accountDetails?.error &&
      !_isEmpty(accountDetails) &&
      accountDetails?.countryCode
    ) {
      dispatch(
        getStoreList({
          countryCode: accountDetails?.countryCode,
          intentChannels: accountDetails?.selectedIntegrations || []
        })
      );
    }
  }, [dispatch, accountDetails]);
  // --- redirect to connect if data lake is not ready
  // if (!accountDetails?.loading && !accountDetails?.error && accountDetails?.isDataLakeReady === false) {
  //   const connectPath = routesMapping?.connect;
  //   return window.location.replace(connectPath);
  // }

  let uniqueChannelList = [];
  for (let index in connectedList) {
    let channelName = connectedList[index].split('-')[0];
    if (!uniqueChannelList.includes(channelName)) {
      uniqueChannelList?.push(channelName);
    }
  }

  const getChannelsCount = marketingAdsChannels => {
    if (uniqueChannelList?.length > marketingAdsChannels?.length) {
      return false;
    }
    const adsChannelList = _filter(uniqueChannelList, item => marketingAdsChannels?.includes(item)) || [];
    return adsChannelList?.length === uniqueChannelList?.length;
  };

  let isAutoDownloadReportEnabled = false;
  let isManaged = false;
  let isTransactionFee = false;
  let isAllChannelInActive = false;

  const filteredChannels = {};
  for (let channel of uniqueChannelList) {
    if (accountDetails[channel]) {
      filteredChannels[channel] = accountDetails[channel]?.map(channelData => ({
        countryCode: channelData?.countryCode,
        currencyCode: channelData?.currencyCode,
        timeLinked: channelData?.timeLinked,
        nickNameID: channelData?.nickName?.id
      }));

      isAutoDownloadReportEnabled =
        isAutoDownloadReportEnabled ||
        accountDetails[channel].some(channelData => channelData.isAutoDownloadReportEnabled === true);
      isManaged = isManaged || accountDetails[channel].some(channelData => channelData.isManaged === true);
      isTransactionFee =
        isTransactionFee || accountDetails[channel].some(channelData => channelData.isTransactionFee === true);
      isAllChannelInActive =
        isAllChannelInActive && accountDetails[channel].every(channelData => channelData.status === 'X');
    }
  }

  useEffect(() => {
    if (
      !_isUndefined(accountDetails) &&
      !_isEmpty(accountDetails) &&
      !accountDetails?.loading &&
      !accountDetails?.error &&
      accountDetails?.merchantID
    ) {
      setIsDemoAccount(!hasWriteAccess);
    }
  }, [accountDetails, hasWriteAccess]);

  return (
    <div className='c-pageContainer'>
      <ScreenSizePopup visible={isPopupVisible} onContinue={handleContinue} />
      <div className='c-pageBody'>
        <div
          className={`c-contentWrapper ${
            !_isEmpty(navigationMenus?.subMenu) &&
            isBrowser &&
            !hideSidebarPaths.includes(pathname) &&
            (isChannelConnected ||
              (!_isEmpty(accountDetails?.selectedIntegrations) && !_isEmpty(selectedIntegrationGoals)))
              ? 'hasSubmenu'
              : ''
          }`}
        >
          {isDemoHost && <DemoHostPage />}
          {!isDemoHost && isDemoAccount && <DemoContent />}
          <MainHeader isChannelConnected={isChannelConnected} className={isDemoAccount ? 'demoAcc' : ''} />

          {((!_isEmpty(accountDetails?.selectedIntegrations) && !_isEmpty(selectedIntegrationGoals)) ||
            isChannelConnected) &&
            !hideSidebarPaths.includes(pathname) && <MainSidebar hasSubmenu={!_isEmpty(navigationMenus?.subMenu)} />}
          {setPopupBackgroundCondition() ? (
            <UpgradePopupBackground pathName={getSubmenu()} />
          ) : isAccessToPage ? (
            <section
              className={`${isMobile ? 'sm' : ''} ${hideSidebarPaths.includes(pathname) ? 'clear' : ''} ${
                isDemoAccount ? 'demoAcc' : ''
              } ${_compact(pathname?.split('/'))?.[0] || ''}`}
            >
              {children}
            </section>
          ) : (
            <AccessDenied />
          )}
        </div>

        {!loading && <Footer />}
        <Helmet titleTemplate='%s | Graas ' title='Dashboard'>
          <script type='text/javascript' src={process.env.REACT_APP_CHAT_HOST + '/js/widget.js'} async></script>
          {process.env.NODE_ENV === 'production' && !_isEmpty(userName) && !_isEmpty(merchantID) && !isDemoAccount && (
            <script type='text/javascript'>
              {`
              function initializeFreshchat() {
                if (window.fcWidget) {
                  // Set user details after Freshchat widget is loaded
                  window.fcWidget.user.setFirstName('${userName + ' - ' + merchantID}');
                  window.fcWidget.user.setEmail('${userName + ' - ' + merchantID}');
                  window.fcWidget.user.setProperties({
                    plan: "Pro",
                    status: "Active"
                  });
                  if (${freshchatInitialized !== 'true'}) {
                      window.fcWidget.init({
                        token: "${process.env.REACT_APP_CHAT_TOKEN}",
                        host: "${process.env.REACT_APP_CHAT_HOST}",
                        //Have the widget open on load by default by setting the below value to true
                        open: true,
                        hideChat: true
                        });
                      document.cookie = 'freshchatInitialized=true; domain=${
                        process.env.REACT_APP_COOKIE_PATH
                      }; expires=1; path=/'
                  }
                } else {
                  // Retry initialization after a short delay if the Freshchat widget is not yet available
                  setTimeout(initializeFreshchat, 1000);
                }
              }
              setTimeout(initializeFreshchat, ${freshchatInitialized !== 'true'} ? 120000 : 1000);`}
            </script>
          )}
        </Helmet>
      </div>
      {isAccessToPage && hasWriteAccess && <ReauthPopUp />}
      {isPopupNeedToShow && (
        <UpgradeContainer
          setShowUpgrade={setShowUpgrade}
          centered={true}
          isCreditExpired={isCreditExpired}
          isDefaultPopup={false}
          isExpired={isExpired}
          showRemindMeLater={showRemindMeLater}
          isFeaturesEnabled={isFeaturesEnabled}
          isExecutorPopup={isExecutorPopup}
        />
      )}

      {accountDetails &&
        !accountDetails?.loading &&
        !accountDetails?.error &&
        process.env.NODE_ENV === 'production' &&
        hasWriteAccess && (
          <ProductFruits
            workspaceCode={process.env.REACT_APP_PRODUCT_FRUIT_KEY}
            language='en'
            user={{
              username: userData?.userName,
              props: {
                merchantID: accountDetails?.merchantID,
                countryCode: accountDetails?.countryCode,
                lastlogintime: accountDetails?.lastLoggedIn,
                linkedChannelTypes: accountDetails?.linkedChannelTypes,
                sellerType: accountDetails?.sellerType,
                timeZone: accountDetails?.timeZone,
                time_created: accountDetails?.timeCreated
                  ? unixToDateFormat(accountDetails.timeCreated * 1000, 'YYYY-MM-DDThh:mm:ss')
                  : '',
                source: accountDetails?.source,
                PrivateBeta: accountDetails?.isPrivateBeta,
                type: accountDetails?.userDetails?.type,
                displayName: accountDetails?.displayName,
                isChromeExtensionInstalled: accountDetails?.isChromeExtensionInstalled,
                isAutoDownloadReportEnabled: isAutoDownloadReportEnabled,
                isManaged: isManaged,
                isTransactionFee: isTransactionFee,
                isAllChannelInActive: isAllChannelInActive,
                ...filteredChannels
              }
            }}
          />
        )}
    </div>
  );
};

export default React.memo(PageSkeleton);
